interface Row {
  id: string;
  name: string;
  autonomy: number | null;
}

/**
 * Classement horizontal, du client le plus en danger au plus couvert.
 * La couleur ne vient pas d'un seuil arbitraire recalculé ici : elle reflète
 * exactement la sévérité que le moteur d'alertes a déjà calculée côté
 * backend (severityByClient), pour ne jamais afficher un rouge que les
 * alertes elles-mêmes ne justifient pas.
 */
export function AutonomyRanking({ rows, severityByClient }: { rows: Row[]; severityByClient: Record<string, string> }) {
  if (rows.length === 0) {
    return <p className="muted">Aucun client à afficher.</p>;
  }
  const finite = rows.filter((r) => r.autonomy != null).map((r) => r.autonomy as number);
  const scaleMax = Math.max(3, ...finite, 0);
  const sorted = [...rows].sort((a, b) => {
    if (a.autonomy == null) return 1;
    if (b.autonomy == null) return -1;
    return a.autonomy - b.autonomy;
  });

  return (
    <div className="autolist">
      {sorted.slice(0, 10).map((r) => {
        const sev = severityByClient[r.id];
        const cls = sev === 'critical' ? 'crit' : sev === 'warning' ? 'warn' : '';
        const color = sev === 'critical' ? 'var(--danger)' : sev === 'warning' ? 'var(--warning)' : 'var(--success)';
        const pct = r.autonomy == null ? 0 : Math.max(3, Math.min(100, (r.autonomy / scaleMax) * 100));
        return (
          <div className="arow" key={r.id} title={r.autonomy == null ? `${r.name} : autonomie non calculable (pas d'historique)` : `${r.name} : ${r.autonomy.toFixed(1)} jour(s) d'autonomie`}>
            <span className="aname">{r.name}</span>
            <div className="atrack">
              {r.autonomy != null && <div className="afill" style={{ width: `${pct}%`, background: color }} />}
            </div>
            <span className={`aval ${cls}`}>{r.autonomy == null ? '—' : `${r.autonomy.toFixed(1)}j`}</span>
          </div>
        );
      })}
      {sorted.length > 10 && <p className="muted" style={{ margin: '2px 0 0' }}>+ {sorted.length - 10} autre(s) client(s) — voir le tableau ci-dessous.</p>}
    </div>
  );
}
